import { collection, deleteDoc, doc, getDoc, getDocs, query, setDoc, Timestamp, where, } from "firebase/firestore";
import { warnUnknownFields } from "./converterWarnings";
import { prepareForFirestore } from "./utils";
const TEMPLATE_OVERRIDE_FIELDS = [
    "id",
    "path",
    "createdAt",
    "updatedAt",
    "templateId",
    "templatePath",
    "backend",
    "content",
    "enabled",
    "updatedBy",
    "checksum",
    "notes",
];
const templateOverrideConverter = {
    toFirestore(value) {
        return prepareForFirestore(value);
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        warnUnknownFields("packages/ui AgentTemplateOverride.fromFirestore", data, TEMPLATE_OVERRIDE_FIELDS);
        return {
            id: snapshot.id,
            path: snapshot.ref.path,
            createdAt: data.createdAt instanceof Timestamp
                ? data.createdAt.toDate().toISOString()
                : data.createdAt || null,
            updatedAt: data.updatedAt instanceof Timestamp
                ? data.updatedAt.toDate().toISOString()
                : data.updatedAt || null,
            templateId: data.templateId || snapshot.id,
            templatePath: data.templatePath || "",
            backend: data.backend || "livekit",
            content: data.content || "",
            enabled: data.enabled ?? true,
            updatedBy: data.updatedBy || "",
            checksum: data.checksum || "",
            notes: data.notes || "",
        };
    },
};
export function templateOverridesCollection(db, companyId, agentId) {
    return collection(db, "companies", companyId, "agents", agentId, "templateOverrides").withConverter(templateOverrideConverter);
}
export function templateOverrideDocument(db, companyId, agentId, overrideId) {
    return doc(db, "companies", companyId, "agents", agentId, "templateOverrides", overrideId).withConverter(templateOverrideConverter);
}
export async function fetchTemplateOverride(db, companyId, agentId, overrideId) {
    const snapshot = await getDoc(templateOverrideDocument(db, companyId, agentId, overrideId));
    return snapshot.exists() ? snapshot.data() : null;
}
export async function listTemplateOverrides(db, companyId, agentId, onlyEnabled = false) {
    const collectionRef = templateOverridesCollection(db, companyId, agentId);
    const snapshot = onlyEnabled
        ? await getDocs(query(collectionRef, where("enabled", "==", true)))
        : await getDocs(collectionRef);
    return snapshot.docs.map((docSnapshot) => docSnapshot.data());
}
export async function createTemplateOverride(db, companyId, agentId, data) {
    const templateId = data.templateId || data.templatePath.replaceAll("/", ".");
    const overrideId = `${data.backend}.${templateId}`;
    await setDoc(templateOverrideDocument(db, companyId, agentId, overrideId), {
        ...data,
        createdAt: new Date(),
        updatedAt: new Date(),
    });
    return overrideId;
}
export async function upsertTemplateOverride(db, companyId, agentId, overrideId, data) {
    await setDoc(templateOverrideDocument(db, companyId, agentId, overrideId), {
        ...data,
        updatedAt: new Date(),
    }, { merge: true });
}
export async function deleteTemplateOverride(db, companyId, agentId, overrideId) {
    await deleteDoc(templateOverrideDocument(db, companyId, agentId, overrideId));
}
